var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 236,
    viewBox: "0 0 236 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.095 124.381V116.758H210.713C210.536 115.872 210.181 115.163 209.827 114.454L214.436 109.845L209.118 104.526L204.509 109.135C203.8 108.781 202.913 108.426 202.204 108.249V101.867H194.581V108.249C193.695 108.426 192.986 108.781 192.277 109.135L187.668 104.526L182.35 109.845L186.959 114.454C186.604 115.163 186.25 116.049 186.072 116.758H179.69V124.381H186.072C186.25 125.267 186.604 125.977 186.959 126.686L182.35 131.295L187.668 136.613L192.277 132.004C192.986 132.358 193.872 132.713 194.581 132.89V139.272H202.204V132.89C203.09 132.713 203.8 132.358 204.509 132.004L209.118 136.613L214.436 131.295L209.827 126.686C210.181 125.977 210.536 125.09 210.713 124.381H217.095ZM203.622 120.658C203.622 122.076 203.09 123.317 202.027 124.381L201.85 124.558C200.963 125.445 199.545 125.977 198.127 126.154H197.95C196.531 126.154 195.29 125.622 194.227 124.558L194.05 124.381C193.163 123.495 192.631 122.076 192.454 120.658V120.481C192.454 119.063 192.986 117.822 194.05 116.758L194.227 116.581C195.113 115.695 196.531 115.163 197.95 114.986H198.127C199.545 114.986 200.786 115.517 201.85 116.581L202.027 116.758C202.913 117.645 203.445 119.063 203.622 120.481V120.658Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.279 235C97.4379 234.468 81.4834 230.391 67.3015 223.477C46.2061 213.196 28.6561 196.886 16.9561 176.5H66.5924C66.7697 177.386 67.1243 178.273 67.4788 179.336C70.4924 189.086 74.2152 197.95 78.647 205.573C87.8652 222.414 100.452 233.405 114.279 235Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.048 176.5C212.843 187.491 204.689 197.241 195.471 205.395C187.493 212.486 178.452 218.514 168.702 223.3C154.343 230.214 138.212 234.291 121.193 234.823C135.021 233.227 147.607 222.414 157.18 205.395C161.612 197.418 165.512 188.2 168.702 177.918C168.88 177.386 169.057 177.032 169.057 176.5H219.048Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169.056 176.499C168.879 177.03 168.702 177.385 168.702 177.917C165.511 188.199 161.788 197.594 157.179 205.394H78.2928C74.0383 197.771 70.3156 188.908 67.1246 179.158C66.7701 178.271 66.5928 177.385 66.2383 176.321H169.056V176.499Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.183 205.394C147.433 222.412 135.024 233.225 121.197 234.821C120.133 234.821 119.07 234.821 118.006 234.821C116.765 234.821 115.524 234.821 114.283 234.821C100.456 233.225 88.0469 222.412 78.2969 205.394H157.183Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.474 205.394H157.183H195.474Z",
    fill: "#8CA0C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.474 205.394H157.183",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2898 205.394H40.708",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.304 55.7783H151.149V176.5H198.304V55.7783Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.679 44.4326H158.593V55.7777H190.679V44.4326Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M181.107 35.0371H167.989V44.4328H181.107V35.0371Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169.937 138.741H160.542V148.137H169.937V138.741Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M188.73 138.741H179.334V148.137H188.73V138.741Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M169.937 157.71H160.542V167.105H169.937V157.71Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M188.73 157.71H179.334V167.105H188.73V157.71Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M169.937 101.159H160.542V110.555H169.937V101.159Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M188.73 101.159H179.334V110.555H188.73V101.159Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M169.937 119.951H160.542V129.346H169.937V119.951Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M188.73 119.951H179.334V129.346H188.73V119.951Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M169.937 82.1914H160.542V91.5871H169.937V82.1914Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M188.73 82.1914H179.334V91.5871H188.73V82.1914Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M169.937 65.1738H160.542V74.5691H169.937V65.1738Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M188.73 65.1738H179.334V74.5691H188.73V65.1738Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0306 176.499H37.876V129.345L61.6306 105.945L85.0306 129.345V176.499Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.668 138.741H47.2725V148.137H56.668V138.741Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6347 138.741H66.2393V148.137H75.6347V138.741Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M56.668 157.71H47.2725V167.105H56.668V157.71Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6347 157.71H66.2393V167.105H75.6347V157.71Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M160.545 72.7949H113.391V176.499H160.545V72.7949Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M132.186 138.739H122.791V148.135H132.186V138.739Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M150.979 138.739H141.584V148.135H150.979V138.739Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M132.186 157.708H122.791V167.103H132.186V157.708Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M150.979 157.708H141.584V167.103H150.979V157.708Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M132.186 101.156H122.791V110.552H132.186V101.156Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M150.979 101.156H141.584V110.552H150.979V101.156Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M132.186 119.947H122.791V129.343H132.186V119.947Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M150.979 119.947H141.584V129.343H150.979V119.947Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M132.186 82.1895H122.791V91.5852H132.186V82.1895Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M150.979 82.1895H141.584V91.5852H150.979V82.1895Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M122.785 95.4863V176.499H75.6309V122.963L103.108 95.4863H122.785Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4189 138.741H85.0234V148.137H94.4189V138.741Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M113.386 138.741H103.99V148.137H113.386V138.741Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4189 157.71H85.0234V167.105H94.4189V157.71Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M113.386 157.71H103.99V167.105H113.386V157.71Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4189 119.95H85.0234V129.345H94.4189V119.95Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M113.386 119.95H103.99V129.345H113.386V119.95Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M132.714 23.8682L130.587 47.2681L124.028 40.709L80.5963 84.1407L61.8054 65.1726L18.1963 108.781V92.6497L61.8054 49.0408L80.5963 67.8316L115.874 32.5545L109.137 25.9954L123.851 24.5773H124.205L132.714 23.8682Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1455 16.9545C76.5182 6.84998 96.55 1 118 1C182.527 1 235 53.2953 235 118C235 182.704 182.705 234.999 118 234.999C53.2955 234.999 1 182.704 1 118C1 91.7633 9.68636 67.6543 24.2227 48.1544",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6031 29.8953V20.8544H47.8031C47.4485 19.968 47.094 18.9043 46.5621 18.018L52.0576 12.5225L45.6758 6.14066L40.1803 11.6361C39.294 11.1043 38.4076 10.7498 37.344 10.3952V2.77246H28.303V10.5725C27.4167 10.927 26.353 11.2816 25.4667 11.8134L19.9712 6.31793L13.5894 12.6998L19.0849 18.1953C18.553 19.0816 18.1985 19.968 17.8439 21.0316H10.0439V30.0726H17.8439C18.1985 30.9589 18.553 32.0226 19.0849 32.909L13.7667 38.2272L20.1485 44.609L25.644 39.1135C26.5303 39.6453 27.4167 39.9999 28.4803 40.3544V48.1545H37.5212V40.3544C38.4076 39.9999 39.4712 39.6453 40.3576 39.1135L45.8531 44.609L52.2349 38.2272L46.7394 32.7317C47.2712 31.8453 47.6258 30.9589 47.9803 29.8953H55.6031ZM39.4712 25.4635C39.4712 27.2362 38.7621 28.6544 37.6985 29.8953L37.5212 30.0726C36.2803 31.1362 34.8621 31.8453 33.0894 31.8453H32.9121C31.1394 31.8453 29.7212 31.1362 28.4803 30.0726L28.303 29.8953C27.2394 28.6544 26.5303 27.2362 26.5303 25.4635V25.2862C26.5303 23.5135 27.2394 22.0953 28.303 20.8544L28.4803 20.6771C29.7212 19.6134 31.1394 18.9043 32.9121 18.9043H33.0894C34.8621 18.9043 36.2803 19.6134 37.5212 20.6771L37.6985 20.8544C38.7621 22.0953 39.4712 23.5135 39.4712 25.2862V25.4635Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProject);
export default __webpack_public_path__ + "static/media/icon-project.55fa0e873620b4e29ce648594f43ab5a.svg";
export { ForwardRef as ReactComponent };